import { FEATURE, selectFeatureTypes, SPLIT } from '@socialive/common';
import selectFeature from '~/selectors/selectFeature';

export default async (action, { dispatch, getState }) => {
  const enabled = selectFeatureTypes(getState());

  window.SPLIT = Object.assign(
    SPLIT,
    Object.entries(FEATURE)
      .filter(([k, v]) => enabled[v.type])
      .reduce((o, [k, v]) => {
        const [treatment, config] = selectFeature(v)(getState());
        return {
          ...o,
          [k]: { treatment, config },
        };
      }, {})
  );
};
